import { lazy } from "react"
import {
  ACL_CREATE,
  ACL_READ,
  ACL_SUBJECT_ORGANIZATION,
  ACL_UPDATE
} from "@configs/acl/constants"

const OrganizationRoutes = [
  {
    path: "/organizations",
    component: lazy(() => import("@views/organizations")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/organizations/add",
    component: lazy(() => import("@views/organizations/CreateOrganization")),
    exact: true,
    meta: {
      action: ACL_CREATE,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/organizations/:id/edit",
    component: lazy(() => import("@views/organizations/OrganizationEditor")),
    meta: {
      action: ACL_UPDATE,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/organizations/:id/change",
    component: lazy(() => import("@views/organizations/ChangeOrganization")),
    meta: {
      action: ACL_UPDATE,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/organizations/:id/register",
    component: lazy(() => import("@views/organizations/RegisterOrganization")),
    meta: {
      action: ACL_UPDATE,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/organizations/:id/applications/:appid",
    component: lazy(() => import("@views/organizations/applications/Application.js")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/organizations/:id",
    component: lazy(() => import("@views/organizations/ViewOrganization")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/invite/:id/accept",
    component: lazy(() => import("@views/organizations/invite/AcceptInvite")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/invite/:id/refuse",
    component: lazy(() => import("@views/organizations/invite/RefuseInvite")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/invite/:id/:messageId/accept-iframe",
    component: lazy(() => import("@views/iframes/AcceptInvite")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/invite/:id/:messageId/refuse-iframe",
    component: lazy(() => import("@views/iframes/RefuseInvite")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/update-member/:memberId/:id/accept",
    component: lazy(() => import("@views/organizations/update/AcceptUpdate")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  },
  {
    path: "/update-member/:id/refuse",
    component: lazy(() => import("@views/organizations/update/RefuseUpdate")),
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_ORGANIZATION
    }
  }
]

export default OrganizationRoutes
